import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const ExternalIDIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14.17 17.39" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M1.3,17.35c-.15,0-.3-.04-.44-.12-.3-.17-.49-.49-.49-.85V1.1C.36.57.78.14,1.3.14h11.54c.52,0,.94.43.94.96v15.28c0,.36-.19.68-.49.85-.3.16-.64.15-.93-.03h0s-5.31-3.38-5.31-3.38l-5.25,3.38c-.15.1-.32.15-.49.15ZM12.88,16.36h0s0,0,0,0ZM7.08,12.83c.17,0,.34.05.49.15l5.23,3.33-.03-15.2-11.48.04.06,15.15,5.23-3.31c.15-.1.32-.14.49-.14Z" />
      </g>
    </SvgIcon>
  );
};
